<template>
    <v-app data-app :full-height="false">
      <!-- <router-view/> -->
      <component :is="proxyType" />
    </v-app>
</template>

<script>
import ProxyDatacenter from './views/proxy-datacenter';
import ProxyResidentialStatic from './views/proxy-residential-static';
import ProxyResidential from './views/proxy-residential';
import ProxyMobile from './views/proxy-mobile';

// function capitalize(str) {
//   return str?.charAt(0).toUpperCase() + str?.slice(1);
// }

export default {
  name: 'App',
  components:
  {
    ProxyDatacenter, ProxyResidentialStatic, ProxyResidential, ProxyMobile
  },
  data: () => ({
    //
  }),
  computed:
  {
    proxyType()
    {
      const serviceType = sessionStorage.getItem("productType")?.toLowerCase().replaceAll('_', '-')
      let component = ''
        try {
            component = require.resolve(`@/views/${serviceType}.vue`)
        } catch (e) {
          console.log(e)
        }
      if(component)
      {
        return serviceType
      }
      else{
        return 'ProxyDatacenter'
      }
    }
  }
};
</script>
<style>
.v-application--wrap
{min-height: unset;}
</style>